'use client';

import { Button, CloseButton } from '@goodneighbor/ui';
import { usePathname } from 'next/navigation';
import Image from 'next/image';
import styles from './promotionalBanner.module.scss';
import { usePromotionalBanner } from './usePromotionalBanner';
import { SHOW_DOWNLOAD_APP_BANNER } from './promotionalBanner.constants';

export type PromotionalBannerProps = {
  className?: string;
};

export default function PromotionalBanner({
  className
}: PromotionalBannerProps) {
  const pathname = usePathname();
  const isRootPath = pathname === '/';
  const { isDismissed, handleDismiss, handleDownload } = usePromotionalBanner();

  if (!SHOW_DOWNLOAD_APP_BANNER || isDismissed || isRootPath) {
    return null;
  }

  return (
    <div className={`${styles.banner} ${className || ''}`}>
      <CloseButton
        size="sm"
        onPress={handleDismiss}
        label="Dismiss banner"
        className={styles.closeButtonMobile}
      />
      <div className={styles.content}>
        <div className={styles.appIcon}>
          <Image
            src="/icons/good-neighbor-logo-app.svg"
            alt="Good Neighbor App"
            width={40}
            height={40}
          />
        </div>
        <div className={styles.textContent}>
          <span className={styles.title}>Get the App</span>
          <span className={styles.subtitle}>The best way to do good.</span>
        </div>
      </div>
      <div className={styles.actions}>
        <Button
          color="primary"
          size="sm"
          onClick={handleDownload}
          className={styles.downloadButton}
        >
          <span className={styles.downloadButtonTextDesktop}>Download App</span>
          <span className={styles.downloadButtonTextMobile}>Use App</span>
        </Button>
        <CloseButton
          size="sm"
          onPress={handleDismiss}
          label="Dismiss banner"
          className={styles.closeButtonDesktop}
        />
      </div>
    </div>
  );
}
